import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellocalfcss/Student-statment-report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

const Student_statement_Report = () => {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [reportData, setReportData] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [studentId, setStudentId] = useState("");
  const [startDate, setStartDate] = useState("2017-01-01");
  const [endDate, setEndDate] = useState("2026-12-31");

  const commonPayload = {
    customer_id: Number(localStorage.getItem("customer_id")) || 1005,
    api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
    language: "en",
    user_id: localStorage.getItem("user_id") || 14857,
    page: 1,
    limit: 999,
  };

  // Runs once on mount — fetches student list and auto-selects the first student
  useEffect(() => {
    const fetchStudentList = async () => {
      try {
        const payload = {
          ...commonPayload,
          student_id: studentId || 58,
          start_date: startDate,
          end_date: endDate,
        };
        const response = await simplePostCall(
          ApiConfig.studentpaymentsRports,
          JSON.stringify(payload)
        );
        if (response?.result && Array.isArray(response.studentSelect) && response.studentSelect.length > 0) {
          setStudentList(response.studentSelect);
          setStudentId(response.studentSelect[0].student_id); // auto-select first student
        }
      } catch (error) {
        console.error("Error fetching student list:", error);
      }
    };
    fetchStudentList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Runs whenever studentId or dates change — fetches report data
  const fetchReportData = useCallback(async () => {
    if (!studentId) return;
    setLoading(true);
    try {
      const payload = {
        ...commonPayload,
        student_id: studentId || 58,
        start_date: startDate,
        end_date: endDate,
      };
      const response = await simplePostCall(
        ApiConfig.studentpaymentsRports,
        JSON.stringify(payload)
      );
      if (response?.result && Array.isArray(response.data)) {
        setReportData(response.data);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  }, [studentId, startDate, endDate]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchReportData();
  }, [fetchReportData]);

  const totalAmount = reportData.reduce((sum, item) => sum + Number(item.amount || 0), 0);

  const handleClear = () => {
    setStartDate("2017-01-01");
    setEndDate("2026-12-31");
  };

  return (
    <div className="student-statement-report-container" style={{ paddingTop: "25px" }}>
      <div className="student-statement-report-header">
        <h3 className="student-statement-report-title">Student Statement Report</h3>
        <button style={{ backgroundColor: "#5db2e8" }} className="btn btn-sm text-white">
          Export
        </button>
      </div>

      <div className="student-statement-report-row">
        <div className="student-statement-report-col">
          <div className="student-statement-report-panel">
            <div className="student-statement-report-panel-body">
              <div className="student-statement-report-table-responsive">
                <table className="student-statement-report-table">
                  <thead>
                    <tr className="student-statement-report-filters">
                      <td colSpan="5">
                        <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "15px" }}>
                          <select
                            className="student-statement-report-input form-select"
                            value={studentId}
                            onChange={(e) => setStudentId(e.target.value)}
                          >
                            <option value="">-- Select Student --</option>
                            {studentList.map((student) => (
                              <option key={student.student_id} value={student.student_id}>
                                {student.student_name} 
                              </option>
                            ))}
                          </select>

                          <input
                            type="date"
                            className="student-statement-report-input"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                          <span style={{ color: "#888" }}>to</span>
                          <input
                            type="date"
                            className="student-statement-report-input"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                          />

                          <button
                            className="btn text-white"
                            style={{ backgroundColor: "#5db2e8", border: "none" }}
                            onClick={handleClear}
                          >
                            Clear
                          </button>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th style={{ textAlign: "center" }}>Sr</th>
                      <th style={{ textAlign: "center" }}>Date</th>
                      <th style={{ textAlign: "center" }}>Fee Type</th>
                      <th style={{ textAlign: "center" }}>Payment Mode</th>
                      <th style={{ textAlign: "center" }}>Amount Paid</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          <div className="text-center">
                            <ScaleLoader
                              color="#F4BB44"
                              style={{ textAlign: "center", padding: "10px" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportData.length > 0 ? (
                      reportData.map((item, index) => (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }}>{index + 1}</td>
                          <td style={{ textAlign: "center" }}>{item.date}</td>
                          <td style={{ textAlign: "center" }}>{item.category_name}</td>
                          <td style={{ textAlign: "center" }}>{item.payment_mode.replace(/_/g, " ")}</td>
                          <td style={{ textAlign: "center" }}>{customer_currency}{Number(item.amount).toLocaleString()}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                          No records found.
                        </td>
                      </tr>
                    )}
                  </tbody>

                  {reportData.length > 0 && (
                    <tfoot>
                      <tr className="fw-bold" style={{ backgroundColor: "#f8f9fa" }}>
                        <td colSpan="4" style={{ textAlign: "right" }}>Total Paid Amount</td>
                        <td style={{ textAlign: "center" }}>{customer_currency}{totalAmount.toLocaleString()}</td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Student_statement_Report;
